var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AboutParallax'),_c('MottoMission'),_c('AboutBeliefs'),_c('AboutNew',{attrs:{"id":"iamnew"}}),_c('GetInTouch',{attrs:{"id":"getintouch"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }